<ng-container [formGroup]="parent">
	<table
		mat-table
		class="list-container mb-3"
		[dataSource]="dataSource"
		matSort
		matSortActive="{{ sort.active }}"
		matSortDisableClear
		formArrayName="array"
		matSortDirection="{{ sort.direction }}"
	>
		<ng-container matColumnDef="empty">
			<th mat-header-cell *matHeaderCellDef class="text-center">
				<em>No contract rates saved</em>
			</th>
		</ng-container>

		<ng-container matColumnDef="service">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Service</th>
			<td mat-cell *matCellDef="let rates">
				{{ rates?.serviceType?.description }}
			</td>
		</ng-container>

		<ng-container matColumnDef="view">
			<th mat-header-cell *matHeaderCellDef>View</th>
			<td mat-cell *matCellDef="let rates; let i = index">
				<button
					type="button"
					mat-icon-button
					(click)="viewContractRates(rates)"
					color="primary"
				>
					<mat-icon>archive</mat-icon>
				</button>
			</td>
		</ng-container>

		<ng-container matColumnDef="edit">
			<th mat-header-cell *matHeaderCellDef>Edit</th>
			<td mat-cell *matCellDef="let rates; let i = index">
				<button
					type="button"
					mat-icon-button
					(click)="editContractRates(rates)"
					color="primary"
				>
					<mat-icon>edit</mat-icon>
				</button>
			</td>
		</ng-container>

		<ng-container matColumnDef="delete">
			<th mat-header-cell *matHeaderCellDef>Delete</th>
			<td mat-cell *matCellDef="let rates; let i = index">
				<button
					type="button"
					mat-icon-button
					color="warn"
					rpsharedConfirm="Delete rates?"
					(onConfirmed)="array.removeAt(findContractRatesIndex(rates))"
				>
					<mat-icon>delete</mat-icon>
				</button>
			</td>
		</ng-container>

		<tr
			mat-header-row
			*matHeaderRowDef="resultColumns"
			[class.hidden]="dataSource.data?.length < 1"
		></tr>
		<tr
			mat-header-row
			*matHeaderRowDef="emptyColumns"
			[class.hidden]="dataSource.data?.length > 0"
		></tr>
		<tr
			mat-row
			*matRowDef="let service; columns: resultColumns"
			[@animateList]
		></tr>
	</table>

	<div fxLayout fxLayoutAlign="space-between center">
		<mat-paginator
			class.hidden="true"
			pageSize="5"
			[pageSizeOptions]="[5, 10]"
		></mat-paginator>
		<button
			*ngIf="canMakeChanges"
			type="button"
			class="mr-4"
			(click)="addContractRates()"
			mat-mini-fab
			color="primary"
			matTooltip="Add Contract Rates"
		>
			<mat-icon>add</mat-icon>
		</button>
	</div>
</ng-container>
